export const goPro = (promise) => {
  return promise.then((data) => [data, undefined]).catch((error) => Promise.resolve([undefined, error]));
};
